/* eslint-disable global-require */
/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
const lozad = require('lozad');
const constants = require('../constants');
const utils = require('../utils');
const cartBase = require('../cart/cart');
const base = require('../product/base');

let GTM;

if (window.dataLayer) {
    GTM = window.datalayerVersion === 'universal'
        ? require('plugin-seo/universalDataLayer/datalayer')
        : require('plugin-seo/dataLayerGA4/datalayer');
}

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}

const closeMinicart = (minicart, page, html, overlay) => {
    minicart.removeClass('show');
    page.removeClass('miniCart-open');
    html.removeClass('no-overflow');
    minicart.find('.container.cart').removeClass('show');
    overlay.hide();
};

const datalayerDeleteProductMinicart = () => {
    const body = $('body');
    let productId;

    $(document).ready(() => {
        body.on('click', 'button.remove-product', (e) => {
            productId = $(e.currentTarget).data('pid');
        });

        body.on('click', 'button.cart-delete-confirmation-btn', () => {
            const datalayerInfo = $(`#delete-${productId}`).data('info');

            if (window.dataLayer) {
                body.trigger('seo:removeProductCart', datalayerInfo);
            }
        });
    });
};

const updateMiniCartCountClass = (count, miniCartCount) => {
    if (miniCartCount.length) {
        const countParsed = parseInt(count, 10);
        miniCartCount.each((index, node) => {
            const miniCartCountNode = $(node);
            // eslint-disable-next-line no-restricted-globals
            if (countParsed === 0 || isNaN(countParsed)) {
                miniCartCountNode.addClass('no-items');
            } else {
                miniCartCountNode.removeClass('no-items');
            }
        });
    }
};

$('.minicart-quantity').on('count:update', (event, count) => {
    if (count && $.isNumeric(count.quantityTotal)) {
        const miniCartQty = $('.minicart-quantity');
        updateMiniCartCountClass(count.quantityTotal, miniCartQty);
        $('.minicart-quantity').text(count.quantityTotal);
    }
});

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessageAndRemoveFromCart(data) {
    $.spinner().stop();
    let status;

    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append('<div class="add-to-wishlist-messages "></div>');
    }
    $('.add-to-wishlist-messages').append(
        `<div class="add-to-wishlist-alert alert text-center ${status}">${data.msg}</div>`,
    );

    setTimeout(() => {
        $('.add-to-wishlist-messages').remove();
    }, 3000);

    const $targetElement = $(`a[data-pid="${data.pid}"]`).parents('.product-card').find('.remove-product');
    const itemToMove = {
        actionUrl: $targetElement.data('action'),
        productID: $targetElement.data('pid'),
        productName: $targetElement.data('name'),
        uuid: $targetElement.data('uuid'),
    };
    $('body').trigger('afterRemoveFromCart', itemToMove);
    setTimeout(() => {
        $('.cart.cart-page #removeProductModal').modal();
    }, 3000);
}

/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist() {
    $('body').on('click', '.product-move .move', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const thisTarget = $(e.currentTarget);
        const url = thisTarget.attr('href');
        const pid = thisTarget.data('pid');
        let optionId = thisTarget.parents('.product-card').find('.lineItem-options-values').data('option-id');
        let optionVal = thisTarget.parents('.product-card').find('.lineItem-options-values').data('value-id');
        optionId = optionId || null;
        optionVal = optionVal || null;
        if (!url || !pid) {
            return;
        }

        $.spinner().start();
        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: {
                pid,
                optionId,
                optionVal,
            },
            success(data) {
                displayMessageAndRemoveFromCart(data);
            },
            error(err) {
                displayMessageAndRemoveFromCart(err);
            },
        });
    });
}

module.exports = {
    wishlist: moveToWishlist,
    cartBase,
    datalayerDeleteProductMinicart,
    miniCartEvents() {
        const minicart = $('.minicart-container');
        const page = $('.page');
        const body = $('body');
        const html = $('html');

        $(document).ready(() => {
            const cartIcon = $('.cart-icon-container.minicart-total');
            const overlay = $('body > .overlay');

            minicart.unbind('mouseleave focusout');
            minicart.unbind('mouseenter focusin touchstart');

            if (window.outerWidth > constants.viewport_onestic.lg || body.hasClass('is-mobile')) {
                body.on('click', '.minicart-container .header .icon-cross-line', () => {
                    closeMinicart(minicart, page, html, overlay);
                });

                overlay.on('touchstart click', () => {
                    closeMinicart(minicart, page, html, overlay);
                });
            }

            $(document).on('touchstart click', '.cart-icon-container.minicart-total', (ev) => {
                ev.preventDefault();
                $('.continue-shopping-button').trigger('click');

                const url = cartIcon.data('minicart');

                const count1 = parseInt($('.minicart-quantity').eq(1).text(), 10);
                const count2 = parseInt($('.minicart-quantity').eq(0).text(), 10);
                let count = 0;
                if (!Number.isNaN(count1)) {
                    count = count1;
                } else if (!Number.isNaN(count2)) {
                    count = count2;
                }

                // Minicart on mobile no available
                if (window.outerWidth < constants.viewport_onestic.lg) {
                    window.location.href = cartIcon[0].href;
                    return;
                }

                minicart.addClass('show');
                page.addClass('miniCart-open');
                html.addClass('no-overflow');
                overlay.show();

                minicart.spinner().start();
                $.get(url, (data) => {
                    minicart.empty();
                    minicart.append(data);
                    utils.updateMiniCartSize(500);
                    const miniCartCount = $('.minicart-quantity');
                    // eslint-disable-next-line no-restricted-globals
                    miniCartCount.text(Number.isNaN(count) ? 0 : count);
                    updateMiniCartCountClass(count, miniCartCount);

                    if (window.dataLayer) {
                        cartIcon.trigger('seo:showMinicart');
                    }

                    cartBase.mehtods.deleteNotAvailableProducts();

                    triggerLozad();
                    $.spinner().stop();
                    
                });
            });

            $('.minicart-quantity').on('count:update', (event, count) => {
                if (count && $.isNumeric(count.quantityTotal)) {
                    const miniCartQty = $('.minicart-quantity');
                    updateMiniCartCountClass(count.quantityTotal, miniCartQty);
                    miniCartQty.text(count.quantityTotal);
                }
            });

            // Event to close minicart if you delete the last item from the minicart
            $('body').on('click', '.cart-delete-confirmation-btn', () => {
                if ($('.product-summary').find('.card-body').length === 1) {
                    minicart.removeClass('show');
                    page.removeClass('miniCart-open');
                    html.removeClass('no-overflow');
                    $('.overlay').remove();
                    setTimeout(() => {
                        const miniCartQty = $('.minicart-quantity');
                        const count = parseInt(miniCartQty.eq(1).text(), 10);
                        updateMiniCartCountClass(count, miniCartQty);
                    }, 500);
                }
            });

            if ($('.cart-page').length) {
                const targetNode = document.querySelector('.cart-page .grand-total');
                const config = { childList: true, subtree: true };

                const callback = (mutationsList, observer) => {
                    if (mutationsList.some(mutation => $(mutation.target).hasClass('cart-page'))) {
                        mutationsList.forEach((mutation) => {
                            mutation.addedNodes.forEach((node) => {
                                $('.cart-page .checkout-btn-mobile span').text($('.cart-page .grand-total').text());
                            });
                        });
                    }
                };

                const observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
        });

        $('body').on('cart:update', (event, grandTotal) => {
            const miniCartShowGrandTotal = $('.minicart-container.show .grand-total');
            if (grandTotal && miniCartShowGrandTotal.length && !$('.cart-page').length) {
                miniCartShowGrandTotal.text(grandTotal);
            }
        });

        $('body').on('click', 'button.add-to-cart-miniCart,button.add-to-cart-inCart', (event) => {
            const { pid } = event.currentTarget.dataset;
            const addToCartUrl = event.currentTarget.dataset.url;

            let pidsObj;
            let setPids;

            $('body').trigger('product:beforeAddToCart', this);

            const form = {
                pid,
                pidsObj,
                childProducts: [],
                quantity: 1,
            };


            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success(data) {
                        base.handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        minicart.removeClass('show');
                        page.removeClass('miniCart-open');
                        html.removeClass('no-overflow');
                        $('.overlay').remove();
                        $.spinner().stop();
                        base.miniCartReportingUrl(data.reportingURL);
                        if ($(event.currentTarget).hasClass('add-to-cart-inCart')) {
                            window.location.reload();
                        }
                    },
                    error() {
                        $.spinner().stop();
                    },
                });
            }
        });
    },
};
